import { useEffect } from 'react';
// Reveal
import Reveal from 'reveal.js';
// LaTeX
import Latex from 'react-latex-next';

import '../../../css/reveal.css';
import '../../../css/math.css';
import '../../../css/diapositivas.css';

type Props = {
    contenido: String
}

const Diapositiva = ({contenido}: Props) => {

    useEffect(() => {
        let deck = new Reveal({
            // hash: true,
            controlsLayout: 'edges',
            center: false,
            backgroundTransition: 'slide',
            transition: 'slide',
            margin: 0.05,
            width: '1280',
            height: '800',
            minScale: 0.2,
            maxScale: 2.0
        })
        deck.initialize({
            // slideNumber: 'c/t',
            // math: {
            //     config: 'TeX-AMS_HTML-full',
            //     TeX: {
            //         Macros: {
            //             R: '\\mathbb{R}',
            //             alo: '\\mathcal{A}',
            //             set: [ '\\left\\{#1 \\; ; \\; #2\\right\\}', 2 ]
            //         }
            //     }
            // },
        });
        console.log('initialized fool')
    },[])

    return (
        <div className="reveal"
            style={{
                background: '#f7f2d3',
                backgroundColor: '#f7f3de',
                // minHeight: '400px'
            }}
        >
            <div className="slides">

                {/* PORTADA */}

                <section 
                    data-transition="slide" 
                    data-align='center' 
                    style={{display: 'block', textAlign: 'justify'}} 
                >
                    <Latex>{`${contenido}`}</Latex>
                </section>

            </div>
        </div>
    )
}

export default Diapositiva;